/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import ArticleCard from "../../../pages/Blogs/ArticleCard";
import {
  SubmenuWrapper,
  SubmenuLinkContent,
  SubmenuTabDescription,
  SubmenuTabIcon,
  SubmenuTabItem,
  SubmenuTabLink,
  SubmenuTabList,
  SubmenuTabTitle,
  FeaturedBlogPostContainer,
} from "./styles";
import { getFeaturedPost } from "../../../services/blog";
import { getMegaPages } from "../../../services/megaPage";
import { RESOURCES_TABS_TITLES } from "../constants";
import GuideCard from "../../Guides/GuideCard";
import MenuCard from "./MenuCard";

function SubMenu({
  data,
  onClickItem,
  isMobile,
  excludeClassname,
  featuredBlogPost: featuredPost,
  setFeaturedBlogPost: setFeaturedPost,
  guide,
  setGuide,
}) {
  const { tabs } = data;

  const navigate = useNavigate();

  const menuRef = useRef(null);

  const [hoveredItem, setHoveredItem] = useState(RESOURCES_TABS_TITLES.Blog);

  const isShowRightSide = !isMobile;
  const needToFetchFeaturedPost = isShowRightSide && !featuredPost;
  const needToFetchGuide = isShowRightSide && !guide;

  useEffect(() => {
    if (needToFetchFeaturedPost) {
      const fetchFeaturedPost = async () => {
        const response = await getFeaturedPost();

        if (!response.success) {
          return;
        }

        setFeaturedPost(response.post);
      };

      fetchFeaturedPost();
    }
  }, [needToFetchFeaturedPost]);

  useEffect(() => {
    if (needToFetchGuide) {
      (async () => {
        const result = await getMegaPages({
          limit: 1,
          offset: 0,
        });

        setGuide(result.megaPages?.[0]);
      })();
    }
  }, [needToFetchGuide]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        !event.target?.classList.contains(excludeClassname)
      ) {
        onClickItem(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOpenBlog = () => {
    navigate(`/blog/${featuredPost.link}`);
  };

  const handleOpenBlogsByTag = () => {
    navigate("/blogs", {
      state: { tag: featuredPost.tag },
    });
  };
  const handleOpenGuide = () => {
    navigate(`/guide/${guide.slug}`);
  };

  const getRightSideContent = () => {
    if (
      hoveredItem === RESOURCES_TABS_TITLES.Professionals ||
      hoveredItem === RESOURCES_TABS_TITLES.Candidates
    ) {
      return (
        <MenuCard data={tabs.find((tab) => tab.title === hoveredItem)?.card} />
      );
    }

    if (hoveredItem === RESOURCES_TABS_TITLES.Guides) {
      return (
        !!guide && (
          <GuideCard
            inHeader
            data={{
              ...guide,
              illustration:
                guide.illustration ||
                "/images/default-guide-image-photo-b.webp",
            }}
            onClick={handleOpenGuide}
          />
        )
      );
    }

    if (featuredPost) {
      return (
        <ArticleCard
          inHeader
          data={featuredPost}
          onClick={handleOpenBlog}
          openBlogsByTag={handleOpenBlogsByTag}
        />
      );
    }

    return null;
  };

  return (
    <SubmenuWrapper $withFeaturedPost={isShowRightSide} ref={menuRef}>
      <SubmenuTabList
        onMouseLeave={() => {
          if (
            hoveredItem === RESOURCES_TABS_TITLES.Guides &&
            !guide &&
            featuredPost
          ) {
            setHoveredItem(RESOURCES_TABS_TITLES.Blog);
          }
        }}
      >
        {tabs.map((tab) => (
          <SubmenuTabItem key={tab.id}>
            <SubmenuTabLink
              to={tab.link}
              onClick={() => onClickItem(tab.key)}
              onMouseOver={() => setHoveredItem(tab.title)}
            >
              <SubmenuTabIcon src={tab.iconSrc} alt={tab.title} />
              <SubmenuLinkContent>
                <SubmenuTabTitle>{tab.title}</SubmenuTabTitle>
                <SubmenuTabDescription>{tab.description}</SubmenuTabDescription>
              </SubmenuLinkContent>
            </SubmenuTabLink>
          </SubmenuTabItem>
        ))}
      </SubmenuTabList>

      {isShowRightSide && (
        <FeaturedBlogPostContainer>
          {getRightSideContent()}
        </FeaturedBlogPostContainer>
      )}
    </SubmenuWrapper>
  );
}

export default SubMenu;
